// extracted by mini-css-extract-plugin
export default {"capitalize-text":"AllTransactionReport_capitalize-text__B1xQg"};